import React, { useState } from "react";
import { Link } from "react-router-dom";
import nftCoin from "../../../assets/meme/nft.png";

import soRekt from "../../../assets/updated/meme/sorektaimemecoinupdated.png";

import skullpunks from "../../../assets/meme/skullpunks.png";
import mello from "../../../assets/meme/mello.png";
// import nftImage from "../../../assets/meme/nft-img.png";
import nftImage from "../../../assets/meme/NFT for gallery.png";

import zombie from "../../../assets/meme/zombie.png";
import "./style.css"; // import your CSS file for styling
// import IconicHeader from "./IconicHeader";
import Footer from "../../Footer/Footer";
import IconicHeader from "./IconicHeaderNew";
import aimemecoin from "../../../assets/updated/meme/aimeme.png";

const AiMemecoin = () => {
  const [selectedTab, setSelectedTab] = useState("Ai Memecoin");

  return (
    <div>
      <div style={{ margin: "100px" }}></div>

      {/* <IconicHeader type="nft" /> */}
      <IconicHeader selectedTab={selectedTab} onChange={setSelectedTab} />

      <section
        style={{
          maxWidth: "650px",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          width: "100%",
          alignItems: "center",
          margin: "100px auto 50px auto",
          gap: "15px",
        }}
      >
        <div>
          <img src={aimemecoin} height="100px" alt="nftcoin" />
        </div>
        <p style={{ fontSize: "40px", fontWeight: "bold" }}>Ai Memecoin</p>
      </section>
      <section className="project-section">
        {/* <h1 className="main-heading">Projects</h1> */}
        <div
          className="project-container"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Project Cards */}
          <div className="project-card">
            <a href="/sorekt-coming-soon">
              <img src={soRekt} alt="Project 1" />
            </a>
            <div>
              <h2>SoRekt</h2>
              <p>
                Introducing SoRekt AI Memecoin: Uniting a community through
                humor and resilience in the face of market challenges. Join us
                on this crypto journey!
              </p>
            </div>
            <a
              href="/sorekt-coming-soon"
              className="learn-more-button"
              rel="noopener noreferrer"
            >
              Learn More
            </a>
          </div>
          {/* Repeat the above project card structure for other projects */}
        </div>
      </section>
      <Footer helpIcon={false} />
    </div>
  );
};

export default AiMemecoin;
